export const ACCENT_COLOR = '#20c997';

export const FONTSIZETITLE = {
    fontSize:'1.4rem',
    'media(min-width:768px)' :{
      fontSize:'1.8rem'
    }
}

export const PADDING = { 
  paddingLeft: "15px",
  paddingRight: "15px",
  paddingTop: '80px',
  paddingBottom: '80px',
  '@media(min-width:768px)' : {
    paddingTop: '160px',
  paddingBottom: '100px',
  }
 }

export const BTN = {
  marginTop: '40px',
  zIndex: 1,
  position: 'relative',
  outline: 0,
  background: 'none',
  padding: '15px 40px',
  borderRadius: '40px',
  fontSize: '1rem',
  fontWeight: 'bold',
  fontFamily: 'Poppins, sans-serif',
  borderBottom: `3px solid ${ACCENT_COLOR}`,
  color: ACCENT_COLOR,
  borderLeft: `3px solid ${ACCENT_COLOR}`,
  borderTop: `3px solid ${ACCENT_COLOR}`,
  borderRight: `3px solid ${ACCENT_COLOR}`,
  transition:'.3s all ease',
  '&:hover': {
    cursor: 'pointer',
    color: '#ffffff',
    background:ACCENT_COLOR
  },
};

export const NAME_SECTION = {
  position: 'absolute',
  left: '50%',
  top: '10%',
  transform: 'translate(-50%, -50%)',
  color: 'whitesmoke',  
  fontSize:'4rem',
  lineHeight:'3.5rem',
  '@media(min-width:768px)' : {
    fontSize:'9rem',
    lineHeight:'9rem',
    top:'40%',
  },
  zIndex: 0,
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 'bold',
  opacity: 0.2,
};
